// The board, devigged and averaged — the baseline every other model is judged
// against.
//
// `runStrategy` already computes this inline for the `market-consensus`
// probability source, because there it can exclude the book it is betting at.
// This module exists so a backtest, a calibration report or a bring-your-own
// comparison can hold it in the same hand as an Elo state: one `predict`,
// one `fit`, one binding.
//
// `book` is the Settings answer to "which book is the market?", carried here
// as a param so the two paths cannot drift: name one and it speaks alone, the
// same devig and the same commission correction `runStrategy` applies. A book
// that is not pricing the match has no opinion, so the board votes instead —
// again as `runStrategy` does, and for the same reason: a run that scored
// nothing on the days its market book was away would flatter itself.

import { consensus } from '../universe.js';
import { assertBefore } from './base.js';
import { bookFairNet } from './sharpAnchor.js';

export const marketConsensus = {
  id: 'market-consensus',
  version: 1,
  sports: null,
  needsFit: false,
  defaultParams: { devig: 'power', weighting: 'equal', exclude: null, book: 'consensus' },

  fit(history, asOf, params = {}, { strict = false } = {}) {
    assertBefore(history, asOf, strict);
    return { ...marketConsensus.defaultParams, ...params, fittedTo: asOf };
  },

  predict(state, match, selection) {
    const method = state?.devig ?? 'power';
    const book = state?.book && state.book !== 'consensus' ? state.book : null;
    if (book && book !== state?.exclude) {
      const p = bookFairNet(match, selection, book, method);
      if (p !== null) return p;
    }
    const view = consensus(match, selection, {
      devig: method,
      weighting: state?.weighting ?? 'equal',
      exclude: state?.exclude ?? null,
    });
    return view?.pFair ?? null;
  },
};
